import { Component, Inject } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FocusMeDirective } from '../focus-me/focus-me.directive';
import { DialogHeaderComponent } from '../modals/dialog-header/dialog-header.component';

@Component({
  selector: 'input-dialog',
  template: `
    <dialog-header>{{ title }}</dialog-header>
    <mat-dialog-content>
      <div class="form-group">
        <input
          name="folderName"
          type="text"
          class="form-control tw-mt-6"
          [focusMe]="{ delay: 250 }"
          tabindex="0"
          [formControl]="inputControl"
          [placeholder]="placeholder"
          (keydown.enter)="dialogRef.close(inputControl.value)"
          (keydown.escape)="dialogRef.close(null)"
        />
      </div>
      @if (inputControl.errors) {
        <div class="alert alert-danger tw-mt-4" role="alert">
          @if (inputControl.errors.noSlash) {
            The new name cannot have slashes.
          }
          @if (inputControl.errors.required) {
            The name is required.
          }
        </div>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="tw-gap-2">
      <button matButton="outlined" [mat-dialog-close]="null">Cancel</button>
      <button
        mat-flat-button
        color="primary"
        [disabled]="!inputControl.valid"
        [mat-dialog-close]="inputControl.value"
      >
        Save
      </button>
    </mat-dialog-actions>
  `,
  imports: [
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    FocusMeDirective,
    MatIconModule,
    DialogHeaderComponent,
  ],
})
export class RenameDialogComponent {
  protected label = '';
  protected placeholder = '';
  protected value = '';
  protected title = '';
  protected notAllowedNames: string[] = [];
  protected inputControl = new FormControl('');

  constructor(
    public dialogRef: MatDialogRef<RenameDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      label: string;
      placeholder: string;
      value: string;
      notAllowedNames: string[];
    },
  ) {
    this.title = this.data.title;
    this.label = this.data.label;
    this.placeholder = this.data.placeholder;
    this.value = this.data.value;
    this.notAllowedNames = this.data.notAllowedNames;
    this.inputControl.setValue(this.value);
    this.inputControl.addValidators([
      this.noSlashValidator,
      Validators.required,
    ]);
  }

  private noSlashValidator = (control: AbstractControl) => {
    if (control.value.includes('/')) {
      return { noSlash: true };
    }
    return null;
  };
}
